import React from 'react'

import { E2E } from '@/lib/e2e-utils'
import { DefaultProps } from '@/travelsuit'

// eslint-disable-next-line no-restricted-syntax
export enum DOMTreePosition {
	self = 'self',
	root = 'root',
	custom = 'custom',
}

export const widthVariantToPx = {
	sm: 600,
	lg: 800,
	xl: 1024,
}

export type ModalVariant = 'success' | 'warning' | 'alert' | 'waiting'

export type ControlButtonElement = React.ReactElement<{ className?: string; color?: string } & Record<string, unknown>>

export interface IPropsModal extends DefaultProps, E2E {
	title?: React.ReactNode
	mobileTitle?: string
	open?: boolean
	controlHeading?: React.ReactNode
	controlButtons?: Array<ControlButtonElement>
	bottomBarRemark?: React.ReactNode
	controlRowComponent?: React.ComponentType<React.PropsWithChildren<{}>>
	contentClassName?: string
	controlsClassName?: string
	contentComponent?: React.ComponentClass | React.FunctionComponent | keyof React.JSX.IntrinsicElements
	width?: number | string | keyof typeof widthVariantToPx
	desktopMaxHeight?: string
	variant?: ModalVariant
	domTreePosition?: DOMTreePosition
	renderInElement?: HTMLElement
	zIndex?: number
	onClose?(e: React.MouseEvent<HTMLElement>): void
}
